import React from "react";

const TeamAreaTwo = () => {
  return (
    <>
      {/*====================== team area start ======================*/}
      <div
        className='team-area bg-relative pd-top-120 pd-bottom-90'
        style={{ backgroundImage: 'url("./assets/img/bg/12.png")' }}
      >
        <div className='container'>
          <div className='section-title text-center'>
            <h6 className='sub-title'>OUR FACILITIES</h6>
            <h2 className='title text-white'>
            Inside Our <span>Manufacturing</span> Facility
            </h2>
          </div>
          <div className='row justify-content-center'>
            <div className='col-12'>
            <div className='text-center' style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                <iframe
                  className='w-100'
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                  src='https://www.youtube.com/embed/mYsVsh2OpCI?si=F_lCpjst5KDH9Up6'
                  allowFullScreen
                  title='Team Video'
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ====================== team area end ======================*/}
    </>
  );
};

export default TeamAreaTwo;
